import React, {useState, useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {addModal, removeModal} from '../../store/app';
import OfferGroup from './OfferGroup';
import OfferGroupRefinance from './OfferGroupRefinance';
import {ModalConfirmSelectedProduct} from './ModalConfirmSelectedProduct';
import ModalSaveCardAddress from './ModalSaveCardAddress';
import {offersByGroup} from '../../lib/misc';

const selectedProductModalId = 'selected_product';
const cardAddressModalId = 'card_address';

function Step4(props) {
  const dispatch = useDispatch();
  const {
    data: {
      offers = [],
      type,
      is_refinance,
      show_delivery_address_cc,
      has_refinancing_contract,
    },
    uuid,
    patchHandler,
  } = props;

  const [addressData, setAddressData] = useState(null);
  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const [selectedOfferDetails, setSelectedOfferDetails] = useState(null);

  const {
    isSelectedOfferWithInsurance,
    isSelectedOfferWithCreditCard,
    isSelectedOfferRevolving,
  } = useMemo(() => {
    const {insurance, is_credit_card, is_revolving_eligible} =
      offers.find(item => item.id === selectedOfferId) || {};

    return {
      isSelectedOfferWithInsurance: insurance === 1,
      isSelectedOfferWithCreditCard: is_credit_card,
      isSelectedOfferRevolving: is_revolving_eligible,
    };
  }, [offers, selectedOfferId]);

  const handleSelectOffer = useCallback(
    (offerId, hasCreditCard, offerDetails) => {
      setSelectedOfferId(offerId);
      offerDetails && setSelectedOfferDetails(offerDetails);

      if (hasCreditCard && show_delivery_address_cc) {
        dispatch(addModal(cardAddressModalId));
      } else {
        dispatch(addModal(selectedProductModalId));
      }
    },
    [dispatch, show_delivery_address_cc],
  );

  const handleSaveAddress = useCallback(
    address => {
      setAddressData(address);
      dispatch(addModal(selectedProductModalId));
    },
    [dispatch],
  );

  const handleSubmit = useCallback(
    formData => {
      dispatch(removeModal(selectedProductModalId));
      patchHandler({
        ...addressData,
        ...formData,
      });
    },
    [dispatch, patchHandler, addressData],
  );

  if (!offers.length) {
    return [];
  }

  return (
    <div className="pb-10">
      <div className="flex flex-wrap justify-center -ml-10 pt-2">
        {has_refinancing_contract
          ? Object.entries(offersByGroup(offers)).map(([key, items]) => (
              <OfferGroupRefinance
                key={key}
                uuid={uuid}
                items={items}
                requestType={type}
                handleSelectOffer={handleSelectOffer}
              />
            ))
          : Object.entries(offersByGroup(offers)).map(([key, items]) => (
              <OfferGroup
                key={key}
                groupId={key}
                items={items}
                uuid={uuid}
                requestType={type}
                handleSelectOffer={handleSelectOffer}
                isCetelemRefinance={is_refinance}
              />
            ))}
      </div>

      <ModalConfirmSelectedProduct
        key={`${selectedOfferId}_${JSON.stringify(addressData)}_${JSON.stringify(selectedOfferDetails)}`}
        closeModal={() => dispatch(removeModal(selectedProductModalId))}
        id={selectedProductModalId}
        isSelectedOfferWithInsurance={isSelectedOfferWithInsurance}
        isSelectedOfferWithCreditCard={isSelectedOfferWithCreditCard}
        isSelectedOfferRevolving={isSelectedOfferRevolving}
        selectedOfferId={selectedOfferId}
        selectedOfferDetails={selectedOfferDetails}
        addressData={addressData}
        onSubmit={handleSubmit}
        uuid={uuid}
        requestType={type}
      />

      {show_delivery_address_cc && (
        <ModalSaveCardAddress
          key={`${cardAddressModalId}_${selectedOfferId}`}
          closeModal={() => dispatch(removeModal(cardAddressModalId))}
          id={cardAddressModalId}
          selectedOfferId={selectedOfferId}
          addressData={addressData}
          onSubmit={handleSaveAddress}
          uuid={uuid}
        />
      )}
    </div>
  );
}

export default Step4;
